class StoreLocator {
    constructor() {
      this.lastChecked = null;
      this._distanceRadioArrowNav = false;
    }

    init() {
      this.bindEvents();      
    }

    bindEvents() {
      document.querySelectorAll('.wd-accordion-header').forEach(header => {
        header.addEventListener('click', this.toggleAccordion.bind(this));
        header.addEventListener('keydown', (event) => {
          if (event.code === 'Enter' || event.code === 'Space') {
            event.preventDefault();
            this.toggleAccordion(event);
          }
        });
      });

    document.querySelectorAll('.wd_distance_filters_body').forEach((group) => {
      this.initDistanceRadioGroup(group);
    });
  }
  //SO2613003040

  /** Roving tabindex + arrow keys; only one distance radio in tab order at a time */
  initDistanceRadioGroup(group) {
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return;

    const updateRovingTabindex = () => {
      const active = radios.find((radio) => radio.checked) || radios[0];
      radios.forEach((radio) => { radio.tabIndex = radio === active ? 0 : -1; });
    };

    updateRovingTabindex();

    radios.forEach((input, index) => {
        input.addEventListener('click', this.toggleRadioButtons.bind(this));
        input.addEventListener('change', () => {
          this.handleRadioChange(input);
          updateRovingTabindex();
        });
        input.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            event.preventDefault();
            this._distanceRadioArrowNav = true;
            const next = radios[(index + 1) % radios.length];
            next.checked = true;
            this.lastChecked = next;
            next.dispatchEvent(new Event('change', { bubbles: true }));
            next.focus();
          } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this._distanceRadioArrowNav = true;
            const prev = radios[(index - 1 + radios.length) % radios.length];
            prev.checked = true;
            this.lastChecked = prev;
            prev.dispatchEvent(new Event('change', { bubbles: true }));
            prev.focus();
          }
        });
      });
    }

    toggleRadioButtons(e) {
      const input = e.target;
      if (this.lastChecked === input) {
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.lastChecked = null;
      } else {
        this.lastChecked = input;
      }
    }

    handleRadioChange(input) {
      const drawer = input.closest('my-store-locator-drawer');
      const select = drawer
        ? drawer.querySelector('.js-store-locator-results-distance')
        : document.querySelector('.js-store-locator-results-distance');
      if (!select) return;

      if (input.checked && input.value !== '') {
        select.value = String(input.value);
      } else {
        select.value = 'all';
      }
      select.dispatchEvent(new Event('change', { bubbles: true }));

    // After selecting a distance, move focus out of the radio group (not on arrow-key navigation)
    if (input.checked && !this._distanceRadioArrowNav) {
      this.moveFocusAfterDistanceRadios(input);
    }
    this._distanceRadioArrowNav = false;
  }

  /** Move keyboard focus to the results summary after a distance radio is chosen */
  moveFocusAfterDistanceRadios(input) {
    const searchArea = input.closest('.my-store-locator-drawer__search');
    const nextEl = searchArea?.querySelector('.js-store-locator-results-count');
    if (nextEl) {
      requestAnimationFrame(() => nextEl.focus());
    }
    }

    toggleAccordion(event) {
      const header = event.target.closest('.wd-accordion-header');
      if (!header) return;

      const content = header.nextElementSibling;
      if (!content || !content.classList.contains('wd-accordion-content')) return;

      const isOpen = window.getComputedStyle(content).display === 'flex';
      content.style.display = isOpen ? 'none' : 'flex';
      header.setAttribute('aria-expanded', String(!isOpen));
      // NVDA only reports aria-expanded when the element takes focus, not when the
      // value changes under a focus that is already there, so announce it explicitly.
      if (typeof wdAnnounceExpanded === 'function') wdAnnounceExpanded(!isOpen, header);

      const icon = header.querySelector('svg');
      if (icon) icon.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
    }
  }

  window.addEventListener('load', () => {
    const storeLocator = new StoreLocator();
    storeLocator.init();
    const myLocationResult = document.querySelector('.js-my-location-result.my-location-result.apl-section-stores-locator-result');
    if(myLocationResult){
      myLocationResult.click();
    }
  });
